var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"esPrimario"},[_c('input',{ref:"radioEsPrimario",staticClass:"radio pointer",attrs:{"type":"radio","name":"radioPrimario","id":'radio-'+_vm.index},domProps:{"checked":_vm.checked(_vm.index)},on:{"change":_vm.select}})])
}
var staticRenderFns = []

export { render, staticRenderFns }